import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const CajaService = {
    getAll: async () => {
        const response = await getAxios().get('/api/caja');
        return response.data?.data || [];
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/caja/${id}`);
        return response.data?.data || response.data;
    },

    create: async (caja) => {
        // En frontend esto se usa como abrir. En backend está en /abrir
        const response = await getAxios().post('/api/caja/abrir', caja);
        return response.data?.data || response.data;
    },

    update: async (id, caja) => {
        const response = await getAxios().put(`/api/caja/${id}`, caja);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/caja/${id}`);
        return response.data;
    },
    
    cerrarCaja: async (id, datosCierre) => {
         const response = await getAxios().post(`/api/caja/cerrar`, datosCierre);
         return response.data?.data || response.data;
    }
};
